module.exports = __webpack_public_path__ + "media/images/franquias-5bfac7f852b600e386306f968e19b32a.jpg";